import { Injectable, OnDestroy } from "@angular/core";
import { AuthService } from "./auth.service";
import { BehaviorSubject, Subscription } from "rxjs";
import { FakturniaNavigationItem } from "@fakturnia/components/navigation/navigation.types";
import { settings } from "environments/environment";

@Injectable({ providedIn: 'root' })
export class NavigationService implements OnDestroy {

    private _subscriptions: Subscription[] = []
    private _isLoggedIn: boolean = false

    private _navigation = new BehaviorSubject<FakturniaNavigationItem[]>([]);
    currentNavigation = this._navigation.asObservable();

    constructor(private _authService: AuthService) {

        this._subscriptions.push(
            this._authService.isLoggedIn$.subscribe({
                next: (isLoggedIn: boolean) => {
                    this._isLoggedIn = isLoggedIn

                    this._buildNavigation()
                }
            })
        )

    }

    private _buildNavigation() {

        const navigation: FakturniaNavigationItem[] = []
        if (this._isLoggedIn) {

            // Pulpit
            navigation.push({
                id: 'pulpit',
                title: 'Pulpit',
                type: 'basic',
                icon: 'tabler_outline:home',
                link: '/konto/pulpit'
            })

            // Dokumenty
            navigation.push({
                id: 'dokumenty',
                title: 'Dokumenty',
                type: 'basic',
                icon: 'tabler_outline:folder',
                link: '/konto/dokumenty'
            })

            // // Dokumenty
            // navigation.push({
            //     id: 'koszty',
            //     title: 'Koszty',
            //     type: 'basic',
            //     icon: 'tabler_outline:folder-dollar',
            //     link: '/konto/koszty'
            // })

            // Klienci
            navigation.push({
                id: 'klienci',
                title: 'Klienci',
                type: 'basic',
                icon: 'tabler_outline:users',
                link: '/konto/klienci'
            })

            // Produkty
            navigation.push({
                id: 'produkty',
                title: 'Produkty',
                type: 'basic',
                icon: 'tabler_outline:package',
                link: '/konto/produkty'
            })

            const ksefEnabled = settings.ksefEnabled
            // Więcej
            navigation.push({
                id: 'inne',
                title: 'Inne',
                type: 'group',
                icon: 'tabler_outline:dots-vertical',
                children: [
                    {
                        id: 'integracje',
                        title: 'Integracje',
                        type: 'basic',
                        // badge: { title: 'Wkrótce dostępne', classes: 'text-primary mx-2' },
                        badge: { title: 'BETA', classes: 'text-primary mx-2' },
                        // Wyłączone gdy REST API jest wyłączone w środowisku (REST API to jedyna integracja)
                        disabled: !settings.enableRestAPI,
                        icon: 'tabler_outline:api',
                        link: '/konto/integracje'
                    },
                    {
                        id: 'ksef',
                        title: 'KSeF - Krajowy System e-Faktur',
                        type: 'basic',
                        icon: 'ksef:ksef-logo',
                        link: '/konto/ksef'
                    },
                    {
                        id: 'raporty',
                        title: 'Raporty',
                        type: 'basic',
                        badge: { title: 'Wkrótce dostępne', classes: 'text-primary mx-2' },
                        disabled: true,
                        icon: 'tabler_outline:list-check',
                        link: '/konto/raporty'
                    },
                    {
                        id: 'statystyki',
                        title: 'Statystyki',
                        type: 'basic',
                        badge: { title: 'Wkrótce dostępne', classes: 'text-primary mx-2' },
                        disabled: true,
                        icon: 'tabler_outline:chart-bar',
                        link: '/konto/statystyki'
                    }
                ]
            })

            this._navigation.next(navigation)
            return
        }

        this._navigation.next(navigation)
    }

    ngOnDestroy(): void {
        this._subscriptions.forEach(sub => sub.unsubscribe())
    }
}